import * as React from 'react';
import Footer from '../Footer';
import Routes from '../routes';

const App = () => {
  return (
    <>
      <Routes />
    </>
  );
};

export default App;
